type ResolveMcpOAuthGatewayOriginInput = {
  configuredGatewayUrl: string;
  electronGatewayUrl?: string | null;
  oauthGatewayOverride?: string | null;
};

export type ResolvedMcpOAuthGatewayOrigin = {
  gatewayOrigin: string;
  source: 'oauthOverride' | 'electron' | 'configured';
};

export function resolveMcpOAuthGatewayOrigin({
  configuredGatewayUrl,
  electronGatewayUrl,
  oauthGatewayOverride,
}: ResolveMcpOAuthGatewayOriginInput): ResolvedMcpOAuthGatewayOrigin {
  const configuredOrigin = configuredGatewayUrl.replace(/\/$/, '');
  const electronOrigin = electronGatewayUrl?.replace(/\/$/, '') ?? null;
  const oauthOverrideOrigin = oauthGatewayOverride?.replace(/\/$/, '') ?? null;

  const candidates = [
    oauthOverrideOrigin,
    electronOrigin,
    configuredOrigin,
  ].filter((origin): origin is string => Boolean(origin));
  const httpsOrigin = candidates.find((origin) =>
    origin.startsWith('https://'),
  );
  const selectedOrigin = httpsOrigin ?? candidates[0] ?? configuredOrigin;

  const source =
    selectedOrigin === oauthOverrideOrigin && oauthOverrideOrigin
      ? 'oauthOverride'
      : selectedOrigin === electronOrigin && electronOrigin
        ? 'electron'
        : 'configured';

  return {
    gatewayOrigin: selectedOrigin,
    source,
  };
}
